const Store = Object.freeze({
  Ios: 'ios',
  Play: 'play',
})

const StoreWithAll = Object.freeze({
  All: 'all',
  ...Store,
})

const Stores = Object.values(Store)

const StoresWithAll = Object.values(StoreWithAll)

const StoreModel = Object.freeze({
  Ios: {
    name: 'iOS',
    shortName: Store.Ios,
    icon: 'apple',
  },
  Play: {
    name: 'Android',
    shortName: Store.Play,
    icon: 'android',
  },
})

const CustomAlertStore = Object.freeze({
  [Store.Ios]: StoreModel.Ios,
  APP_STORE: StoreModel.Ios,
  [Store.Play]: StoreModel.Play,
  PLAY_STORE: StoreModel.Play,
})

const CustomAlertHistory = Object.freeze({
  APP_STORE: StoreModel.Ios,
  PLAY_STORE: StoreModel.Play,
})

const StoreSwitchOptions = [
  {
    icon: 'app-store-colorful',
    value: Store.Ios,
  },
  {
    icon: 'play-store-colorful',
    value: Store.Play,
  },
]

const StoreSwitchOptionsWithAll = [
  {
    label: 'All',
    value: StoreWithAll.All,
  },
  ...StoreSwitchOptions,
]

export {
  CustomAlertHistory,
  CustomAlertStore,
  Store as default,
  Store,
  StoreModel,
  Stores,
  StoreSwitchOptions,
  StoreSwitchOptionsWithAll,
  StoresWithAll,
  StoreWithAll,
}
